/*
 * File: GeneralPreferences.js
 * Project: mp-mobile-app
 *
 * Created by Dillon Neukirch on 05/20/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Model for creating General Preference List on Preferences page
 */
const GeneralPreferences = [
  {
    label: "General",
    type: "header"
  },
  {
    name: "defaultView",
    label: "Default View",
    type: "radiogroup",
    value: "dashboard",
    options: [
      {
        id: 0,
        name: "Dashboard"
      },
      {
        id: 1,
        name: "Schedule"
      },
      {
        id: 2,
        name: "Orders"
      },
      {
        id: 3,
        name: "Patients"
      },
      {
        id: 4,
        name: "Referrers"
      }
    ]
  }
];

export default GeneralPreferences;
